import useDebugSettingsField from '@/features/monitor/developer/monitor-debug-settings/useDebugSettingsField';
import DefaultLogger from '@/lib/debug/logger/DefaultLogger';

export default function applyDebugCheckerBasedOnMonitorDebugSettingsToDefaultLogger() {
  const { value: isEnableLogging } = useDebugSettingsField('isEnableLogging');

  DefaultLogger.appendIsDebugChecker({
    isDebug: () => isEnableLogging.value,
  });
}
